import {L10nConfig} from 'angular-l10n';

import {i18nDeDe, i18nEnUs} from './languages';
import {libI18nDeDe, libI18nEnUs} from "@yasc/yasc-material-components";

export const l10nConfig: L10nConfig = {
    format: 'language-region',
    providers: [
        {
            name: 'app', asset: {
                'en-US': {...libI18nEnUs, ...i18nEnUs},
                'de-DE': {...libI18nDeDe, ...i18nDeDe}
            },
        }
    ],
    fallback: false,
    cache: true,
    keySeparator: '.',
    defaultLocale: {
        language: 'de-DE',
        currency: 'EUR',
        timeZone: 'Europe/Berlin',
        units: {length: 'kilometer'},
    },
    schema: [
        {
            locale: {
                language: 'de-DE',
                dateLanguage: "de-DE",
                currency: 'EUR',
                timeZone: 'Europe/Berlin',
                units: {length: 'kilometer'},
            },
            dir: 'ltr',
            text: 'Deutschland',
        },
        {
            locale: {
                language: 'en-US',
                currency: 'USD',
                timeZone: 'America/Los_Angeles',
                units: {length: 'mile'},
                dateLanguage: "en-US"
            },
            dir: 'ltr',
            text: 'United States',
        },
    ],
};
